/**
 * Server-side proxy for internal-only Supabase edge functions.
 * Uses hub-internal-proxy (staff JWT) — secret never ships in the browser bundle.
 */

import { callHubStaffEdgeFunction } from './hubEdgeFunction'

export type InternalEdgeFunctionTarget =
  | 'notify-student-status'
  | 'send-placement-email'
  | 'send-onboarding-email'
  | 'send-existing-student-portal-email'
  /** @deprecated Prefer calculateMatchLevel from @fintree/utils — match-score edge fn retained for legacy Hub proxy callers only */
  | 'match-score'

/** POST to an internal edge function via the Hub staff proxy. */
export async function callInternalEdgeFunction(
  target: InternalEdgeFunctionTarget,
  payload: Record<string, unknown>,
): Promise<Response> {
  return callHubStaffEdgeFunction('hub-internal-proxy', { target, payload })
}
